import { PageLocatorMap } from '../types/PageLocatorMap';

export const loanDocumentSuccessPage = {
  footer: {
    root: 'loan-document-success.footer.root',
  },
  form: {
    h1: 'loan-document-success.form.h1',
    h2: 'loan-document-success.form.h2',
    root: 'loan-document-success.form.root',
    submitButton: 'loan-document-success.form.submit-button',
  },
  header: {
    drawerButton: 'loan-document-success.header.drawer-button',
    root: 'loan-document-success.header.root',
  },
} as const satisfies PageLocatorMap;
